module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-11-d813eb0042ef867ee32535b25c86ab24.jpg";